import backend from '@common/backend';

const BASE = '/scorm';

type GetScormDataParams = {
	student_id?: number;
};

export const playScorm = (uuid: string) => backend
	.get(`${BASE}/play/${uuid}`);

export const getScormData = (scormId: number, studentId?: number) => backend
	.get(`${BASE}/track/${scormId}`, {
		params: typeof studentId === 'number' ? ({ student_id: studentId } as GetScormDataParams) : undefined,
	});

export const getScormDataForUser = (scormId: number, studentId: number) =>
	backend.get(`${BASE}/track/${scormId}/${studentId}`);

export const postScormData = (uuid: string, data: any) => backend
	.post(`${BASE}/track/${uuid}`, data);

export const postScormLog = (data: any) => backend
	.post(`${BASE}/log`, data);
